<template>
  <modal name="widgetPartyInfoModal" :header="$t('widgetVerify.title')" :loading="loading">
    <div class="widget-verify">
      <p>{{ $t('widgetVerify.enterNameAndEmail') }}</p>
      <p>{{ $t('widgetVerify.confirmationInstructions') }}</p>
      <p><b>{{ $t('widgetVerify.notSignedUntilVerified') }}</b></p>
      <hr />
      <div>
        <p>
          <b>{{ $t('widgetVerify.yourName') }}</b>
          <ValidationProvider ref="nameInput" rules="required" :name="$t('widgetVerify.name')" v-slot="{ errors }">
            <input type="text" class="widget-verify__text-input" v-model="widgetSignerName" />
            <span class="validation-message" v-if="errors[0]">
              <icon name="times" height="16" width="16"></icon>
              <span class="text">{{ errors[0] }}</span>
            </span>
          </ValidationProvider>
        </p>
        <p>
          <b>{{ $t('widgetVerify.yourEmail') }}</b>
          <ValidationProvider ref="emailInput" rules="required|email" :name="$t('widgetVerify.email')" v-slot="{ errors }">
            <input type="email" class="widget-verify__text-input" v-model="widgetSignerEmail" />
            <span class="validation-message" v-if="errors[0]">
              <icon name="times" height="16" width="16"></icon>
              <span class="text">{{ errors[0] }}</span>
            </span>
          </ValidationProvider>
        </p>
      </div>
      <div class="widget-verify__buttons">
        <app-button
          :text="$t('widgetVerify.confirmSignature')"
          iconName="check"
          :action="confirmSignature"
          class="float-right"
          :isActive="!loading"></app-button>
      </div>
    </div>
  </modal>
</template>

<script>
import AppButton from '@/components/AppButton'
import { submitEnvelope } from '@/store/api'
import { ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import Modal from '@/components/Modal'

extend('required', required)
extend('email', email)

export default {
  name: 'widget-verify',
  components: {
    AppButton,
    ValidationProvider,
    Modal
  },
  data () {
    return {
      widgetSignerName: '',
      widgetSignerEmail: '',
      loading: false
    }
  },
  methods: {
    async confirmSignature () {
      const validateName = await this.$refs.nameInput.validate()
      const validateEmail = await this.$refs.emailInput.validate()

      if (validateName.valid && validateEmail.valid) { // TODO Find a better approach with vee-validate
        this.loading = true
        submitEnvelope({
          store: this.$store,
          widgetSignerName: this.widgetSignerName,
          widgetSignerEmail: this.widgetSignerEmail
        }).then(() => {
          this.$bus.$emit('submitEnvelope', {
            response: {
              status: 'verify'
            }
          })
        }).finally(() => {
          this.loading = false
        })
      } else {
        alert(this.$t('widgetVerify.nameAndEmailRequired'))
        this.$bus.$emit('loadingStop')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .widget-verify
    p
      &:first-child
        margin-top: 0
    input
      width: 100%
      max-width: 100%
      height: 38px
      font-size: 16px
      border: 1px solid $color-border
    b
      display: block
    hr
      border: 0.5px solid $color-border
    .validation-message
      font-size: 0.8em
      font-weight: bold
      color: $color-error
      .text, svg
        vertical-align: middle
        display: inline-block
      svg
        margin-right: 5px
    &__buttons
      padding-top: $spacing-base
      border-top: 1px solid $color-border
      @include clearfix
</style>
